let __DEBUG_ON = false

if (localStorage.__DEBUG_ON) {
  __DEBUG_ON = ['true', 'on', '1'].includes(localStorage.__DEBUG_ON)
}

export const __isDebugOn = () => __DEBUG_ON

export const __setDebugOn = (debugOn: boolean) => {
  __DEBUG_ON = Boolean(debugOn)
}

export const __isLocalhost = window.location.hostname.includes('localhost')

export const __console = {
  log: (...args: any[]): void => {
    if (__DEBUG_ON) {
      console.log(...args)
    }
  },
  info: (...args: any[]): void => {
    if (__DEBUG_ON) {
      console.info(...args)
    }
  },
  debug: (...args: any[]): void => {
    if (__DEBUG_ON) {
      console.debug(...args)
    }
  },
  warn: (...args: any[]): void => {
    if (__DEBUG_ON) {
      console.warn(...args)
    }
  },
  error: (...args: any[]): void => {
    if (__DEBUG_ON) {
      console.error(...args)
    }
  },
}

export const __log = __console.log
export const __info = __console.info
export const __warn = __console.warn
export const __error = __console.error
